export default __webpack_public_path__ + "static/media/project1.206d9710.webp";